export default ["Jr.", "Sr.", "II", "III"];
